import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";

import { ReactSVG } from "react-svg";
import ScalabilityDiagramCloud from "@/assets/6183218_3040059-simple.svg";
import { useNavigate } from "react-router";

export default function AboutSection() {
  const navigate = useNavigate();
  return (
    <section className="w-full">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="grid gap-10 lg:grid-cols-2 items-center">
          <div className="flex flex-col justify-center space-y-4">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
              Designed for Scale
            </h2>
            <p className="max-w-[600px] text-muted-foreground md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
              Whether you're managing a handful of servers or thousands,
              AptFleet scales with your infrastructure. Simplify your package
              management and reduce downtime with our powerful, cloud-based
              solution.
            </p>
            <Button
              className="w-fit group"
              size="lg"
              onClick={() => navigate("/learn-more")}
            >
              Learn More
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>
          <Card className="overflow-hidden border-none shadow-none">
            <div className="">
              <ReactSVG
                src={ScalabilityDiagramCloud}
                className=" w-auto transition-transform duration-300 hover:scale-110"
              />
              <div className="hidden">
                <a href="https://www.freepik.com/free-vector/cloud-hosting-concept-illustration_6183218.htm#fromView=keyword&page=1&position=1&uuid=c0301350-a89a-4876-bb4b-4a96f6e183ee&query=Cloud+Computing">
                  Image by storyset on Freepik
                </a>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}
